import { tripCustomMilestone, version, version2 } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
    getTripCustomMilestoneList(params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(tripCustomMilestone.tripCustomMilestoneBase, {
                    params: params,
                })
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    revertTripMilestone(id,payload) {
        return new Promise((resolve, reject) => {
          axios
            .patch(
              `${tripCustomMilestone.tripCustomMilestoneBase}${id}/revert_trip_milestone/`,
              payload
            )
            .then((res) => {
              resolve(handleResponse(res));
            })
            .catch((err) => {
              reject(handleError(err));
            });
        });
      },
        updateTripMilestones(payload) {
            return new Promise((resolve, reject) => {
                axios
                    .patch(`${tripCustomMilestone.tripCustomMilestoneBase}${payload.id}/`, payload.data)
                    .then((res) => {
                        resolve(handleResponse(res));
                    })
                    .catch((err) => {
                        reject(handleError(err));
                    });
            });
        },

   
});

